<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <!-- <Header class="header" :type="'home'"></Header> -->
    <!-- <a @click="newOpen">localAndorid</a>
    <a @click="iosOpen">localIOS</a> -->
    <!-- <div id="first">
      <h2>
        <a
          id="applink"
          href="intent://qmenu=voicerecg&version=1#Intent;scheme=naversearchapp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.search;end"
        ></a>
      </h2>
    </div> -->
    <div id="second"></div>
    <div class="container">
      <!-- content(s) -->
      <div id="content" style="padding-top: 0;">
        <section style="margin-top: 0;">
          <div class="img">
            <img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1604554461491_share_bridge.jpg" />
          </div>

          <!-- btnArea (s) -->
          <div class="btnArea mt20">
            <button type="button" class="btn_p" @click="goHome">앱 설치 하러가기</button>
          </div>
          <!-- btnArea (e) -->
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
// import $ from 'jquery';
// import AppTest from '@/components/comm/AppTest';

let url = '';

export default {
  name: 'RenderPage',
  mounted() {
    const baseUrl = process.env.VUE_APP_BASE_URL;
    const type = this.$route.params.type;
    const param1 = this.$route.params.param1;
    const param2 = this.$route.params.param2;

    if (type == 'friend') {
      url = 'friendRecommendRecv/' + param1 + '/' + param2;
    } else if (type == 'pdp') {
      url = 'product/category/detail/' + param1;
    } else if (type == 'event') {
      if (param1 == 'dailyEvent') url = 'event/dailyEvent';
      else url = 'event/detail/' + param1;
    } else if (type == 'theme') {
      url = 'theme/detail/' + param1;
    } else if (type == 'main') {
      url = '/';
    }

    url = baseUrl + url;
    console.log('==========================');
    console.log(url);

    if (/Android/i.test(navigator.userAgent)) {
      this.newOpen(url);
    } else if (/iPhone/i.test(navigator.userAgent)) {
      this.iosOpen(url);
    }
  },
  methods: {
    newOpen(url) {
      window.newOpen(url);
    },
    iosOpen(url) {
      window.iosOpen(url);
    },
    goHome() {
      if (/Android/i.test(navigator.userAgent)) {
        location.href = 'market://details?id=kr.co.welrixrental';
        //location.href = 'intent://welrixrental?deeplink=' + url + '#Intent; scheme=welmall; package=kr.co.welrixrental; end';
        // location.href =
        //   'intent://qmenu=voicerecg&version=1#Intent;scheme=naversearchapp;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=com.nhn.android.search;end';
      } else if (/iPhone/i.test(navigator.userAgent)) {
        location.href = 'https://itunes.apple.com/app/id1532374452';
        //location.href = "https://itunes.apple.com/app/id393499958";
      }
    },
  },
};
</script>
